// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"7aea5aff","472":"11117cd9"}[chunkId] + ".chunk.js";
};